import { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Select from "react-select";
import _ from "lodash";

import classes from "../maintainers.module.scss";

import { customStyles } from "./applications.constants";
import { validRoles } from "@/services/Utils";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const ApplicationsFilter = ({ filter, applyFilter, customers }) => {
	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const [filterCustomer, setFilterCustomer] = useState(filter.filter_customer_id);
	const [filterDate, setFilterDate] = useState(filter.filter_date);
	const [filterDateTo, setFilterDateTo] = useState(filter.filter_date_to);

	const handleApplyFilter = () => {
		applyFilter({
			filterCustomer,
			filterDate,
			filterDateTo,
		});
	};

	const handleCleanFilter = () => {
		applyFilter({
			filterCustomer: "",
			filterDate: "",
			filterDateTo: "",
		});
	};

	return (
		<Col md={3} className={classes.filter}>
			<h4 className={classes.filterTitle}>Filtros</h4>
			<hr style={{ marginTop: "0.5em", marginBottom: "0.5em" }} />

			<div className={classes.divContent}>
				{isAdmin && (
					<Row className={classes.divForm}>
						<Col md={12} className={classes.divLabel}>
							<span className={classes.label}>Cliente</span>
						</Col>
						<Col md={12}>
							<Select
								value={
									customers &&
									customers.filter(
										(a) =>
											filterCustomer && filterCustomer.length > 0 && _.map(filterCustomer.split(","), Number).includes(Number(a.value)),
									)
								}
								isMulti
								placeholder={<div>Seleccione</div>}
								options={customers ? customers : []}
								onChange={(value) => {
									let baseValue = [];
									value.forEach((element) => {
										baseValue.push(element.value);
									});

									setFilterCustomer(baseValue.length !== 0 ? baseValue.toString() : "");
								}}
								components={{ NoOptionsMessage }}
								styles={customStyles}
							/>
						</Col>
					</Row>
				)}

				<Row className={classes.divForm}>
					<Col md={12} className={classes.divLabel}>
						<span className={classes.label}>Fecha</span>
					</Col>
					<Col md={6} style={{ paddingRight: "5px" }}>
						<small>Desde</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={filterDate}
							onChange={(e) => setFilterDate(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
							style={{ fontSize: "13px" }}
						/>
					</Col>
					<Col md={6} style={{ paddingLeft: "5px" }}>
						<small>Hasta</small>
						<Form.Control
							type="text"
							name="created_at"
							placeholder=" "
							value={filterDateTo}
							onChange={(e) => setFilterDateTo(e.target.value)}
							onFocus={(e) => (e.target.type = "date")}
							style={{ fontSize: "13px" }}
						/>
					</Col>
				</Row>
			</div>

			<div className={classes.divFooter}>
				<Button className={classes.buttonClean} onClick={() => handleCleanFilter()}>
					Limpiar
				</Button>

				<Button className={classes.buttonApply} onClick={() => handleApplyFilter()}>
					Aplicar
				</Button>
			</div>
		</Col>
	);
};

export default ApplicationsFilter;
